import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Layout from "./WebLayout/layout";
import LoginPage from "./Pages/LoginPage";
import PWAInstallPrompt from "./Components/PWAInstallPrompt";
import OfflineNotifier from "./Components/OfflineNotifier";
import {
  loadHome,
  loadOrders,
  loadProducts,
  loadProductsDetail,
  loadProfile,
  loadSubscriptions,
  retryLazyImport,
} from "./routeLoaders";

const Home = lazy(loadHome);
const Products = lazy(loadProducts);
const ProductsDetail = lazy(loadProductsDetail);
const Order = lazy(loadOrders);
const Suscriptions = lazy(loadSubscriptions);
const AdminApp = lazy(() => retryLazyImport(() => import("./Admin/AdminApp")));

const PurchasePage = lazy(() => retryLazyImport(() => import("./Pages/Purchase/PurchasePage")));
const PrimeMemberPage = lazy(() => retryLazyImport(() => import("./Pages/Prime/PrimeMemberPage")));
const PrimeSuccessPage = lazy(() => retryLazyImport(() => import("./Pages/Prime/PrimeSuccessPage")));
const InvoicePage = lazy(() => retryLazyImport(() => import("./Pages/Invoice/InvoicePage")));
const UserInfo = lazy(loadProfile);

const isAuthenticated = () => {
  try {
    return Boolean(localStorage.getItem("magizh_user"));
  } catch {
    return false;
  }
};

const ProtectedRoute = ({ children }) =>
  isAuthenticated() ? children : <Navigate to="/welcome" replace />;

const basename = process.env.NODE_ENV === "production" ? "/" : "";

export default function App() {
  return (
    <div className="App">
      <OfflineNotifier />
      <PWAInstallPrompt />
      <Router basename={basename}>
        <Suspense fallback={<div className="appLoading" role="status">Loading...</div>}>
          <Routes>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/welcome" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Home />} />
              <Route path="home" element={<Home />} />
              <Route path="products" element={<Products />} />
              <Route path="product-details" element={<ProductsDetail />} />
              <Route path="subscriptions" element={<Suscriptions />} />
              <Route path="prime-member" element={<PrimeMemberPage />} />
              <Route path="prime-success" element={<PrimeSuccessPage />} />
              <Route path="prime-success/:id" element={<PrimeSuccessPage />} />
              <Route path="purchase" element={<PurchasePage />} />
              <Route path="purchase/:id" element={<PurchasePage />} />
              <Route path="invoice/:id" element={<InvoicePage />} />
              <Route path="orders" element={<Order />} />
              <Route path="profile" element={<UserInfo />} />
            </Route>
            <Route path="*" element={<Navigate to="/welcome" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

